module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "man",
    attrs: {
      "id": "man"
    }
  }, [_c('section', {
    staticClass: "man-top"
  }, [_vm._m(0), _vm._v(" "), (_vm.screenWidth > 1200) ? _c('img', {
    attrs: {
      "src": require("../assets/images/man-title.png"),
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/images/man-title-m.png"),
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.screenWidth > 1200) ? _c('section', {
    staticClass: "man-pd-container"
  }, _vm._l((_vm.manProduct), function(category, index) {
    return _c('div', {
      staticClass: "category-conatiner"
    }, [_c('div', {
      staticClass: "category-title"
    }, [_c('h1', {
      staticClass: "category-name"
    }, [_vm._v(_vm._s(_vm.manCategory[index].title) + " ")])]), _vm._v(" "), _c('div', {
      key: category[1].no,
      staticClass: "pd-item pd-top1",
      style: ({
        backgroundImage: 'url(' + _vm.setImageUrl(category[1].image) + ')'
      }),
      attrs: {
        "data-toggle": "modal",
        "data-target": "#Modal"
      },
      on: {
        "click": function($event) {
          _vm.saveModalShowPd(category[1])
        }
      }
    }, [_c('div', {
      staticClass: "pd-cover"
    }, [_c('h4', {
      staticClass: "pd-brand"
    }, [_vm._v(" " + _vm._s(category[1].brand) + " ")]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(category[1].product) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "pd-detail"
    }, [_vm._v("\n\t\t\t\t\t\t產品說明\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
      staticClass: "pd-sm"
    }, [_c('div', {
      key: category[2].no,
      staticClass: "pd-item pd-top2",
      style: ({
        backgroundImage: 'url(' + _vm.setImageUrl(category[2].image) + ')'
      }),
      attrs: {
        "data-toggle": "modal",
        "data-target": "#Modal"
      },
      on: {
        "click": function($event) {
          _vm.saveModalShowPd(category[2])
        }
      }
    }, [_c('div', {
      staticClass: "pd-cover"
    }, [_c('h4', {
      staticClass: "pd-brand"
    }, [_vm._v(" " + _vm._s(category[2].brand) + " ")]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(category[2].product) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "pd-detail"
    }, [_vm._v("\n\t\t\t\t\t\t\t產品說明\n\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
      key: category[3].no,
      staticClass: "pd-item pd-top3",
      style: ({
        backgroundImage: 'url(' + _vm.setImageUrl(category[3].image) + ')'
      }),
      attrs: {
        "data-toggle": "modal",
        "data-target": "#Modal"
      },
      on: {
        "click": function($event) {
          _vm.saveModalShowPd(category[3])
        }
      }
    }, [_c('div', {
      staticClass: "pd-cover"
    }, [_c('h4', {
      staticClass: "pd-brand"
    }, [_vm._v(" " + _vm._s(category[3].brand) + " ")]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(category[3].product) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "pd-detail"
    }, [_vm._v("\n\t\t\t\t\t\t\t產品說明\n\t\t\t\t\t\t")])])])]), _vm._v(" "), _c('div', {
      key: category[4].no,
      staticClass: "pd-item pd-star",
      style: ({
        backgroundImage: 'url(' + _vm.setImageUrl(category[4].image) + ')'
      }),
      attrs: {
        "data-toggle": "modal",
        "data-target": "#Modal"
      },
      on: {
        "click": function($event) {
          _vm.saveModalShowPd(category[4])
        }
      }
    }, [_c('div', {
      staticClass: "pd-cover"
    }, [_c('h4', {
      staticClass: "pd-brand"
    }, [_vm._v(" " + _vm._s(category[4].brand) + " ")]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(category[4].product) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "pd-detail"
    }, [_vm._v("\n\t\t\t\t\t\t產品說明\n\t\t\t\t\t")])])])])
  })) : _c('section', {
    staticClass: "man-pd-container"
  }, _vm._l((_vm.manProduct), function(category, index) {
    return _c('div', {
      staticClass: "category-conatiner"
    }, [_c('div', {
      staticClass: "category-title"
    }, [_c('h1', {
      staticClass: "category-name"
    }, [_vm._v(_vm._s(_vm.manCategory[index].title) + " ")])]), _vm._v(" "), _c('div', {
      key: category[1].no,
      staticClass: "pd-item pd-top1",
      style: ({
        backgroundImage: 'url(' + _vm.setImageUrl(category[1].image) + ')'
      }),
      attrs: {
        "data-toggle": "modal",
        "data-target": "#Modal"
      },
      on: {
        "click": function($event) {
          _vm.saveModalShowPd(category[1])
        }
      }
    }, [_c('div', {
      staticClass: "pd-cover"
    }, [_c('h4', {
      staticClass: "pd-brand"
    }, [_vm._v(" " + _vm._s(category[1].brand) + " ")]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(category[1].product) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "pd-detail"
    }, [_vm._v("\n\t\t\t\t\t\t產品說明\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
      key: category[2].no,
      staticClass: "pd-item pd-top2",
      style: ({
        backgroundImage: 'url(' + _vm.setImageUrl(category[2].image) + ')'
      }),
      attrs: {
        "data-toggle": "modal",
        "data-target": "#Modal"
      },
      on: {
        "click": function($event) {
          _vm.saveModalShowPd(category[2])
        }
      }
    }, [_c('div', {
      staticClass: "pd-cover"
    }, [_c('h4', {
      staticClass: "pd-brand"
    }, [_vm._v(" " + _vm._s(category[2].brand) + " ")]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(category[2].product) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "pd-detail"
    }, [_vm._v("\n\t\t\t\t\t\t產品說明\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
      key: category[3].no,
      staticClass: "pd-item pd-top3",
      style: ({
        backgroundImage: 'url(' + _vm.setImageUrl(category[3].image) + ')'
      }),
      attrs: {
        "data-toggle": "modal",
        "data-target": "#Modal"
      },
      on: {
        "click": function($event) {
          _vm.saveModalShowPd(category[3])
        }
      }
    }, [_c('div', {
      staticClass: "pd-cover"
    }, [_c('h4', {
      staticClass: "pd-brand"
    }, [_vm._v(" " + _vm._s(category[3].brand) + " ")]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(category[3].product) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "pd-detail"
    }, [_vm._v("\n\t\t\t\t\t\t產品說明\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
      key: category[4].no,
      staticClass: "pd-item pd-star",
      style: ({
        backgroundImage: 'url(' + _vm.setImageUrl(category[4].image) + ')'
      }),
      attrs: {
        "data-toggle": "modal",
        "data-target": "#Modal"
      },
      on: {
        "click": function($event) {
          _vm.saveModalShowPd(category[4])
        }
      }
    }, [_c('div', {
      staticClass: "pd-cover"
    }, [_c('h4', {
      staticClass: "pd-brand"
    }, [_vm._v(" " + _vm._s(category[4].brand) + " ")]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(category[4].product) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "pd-detail"
    }, [_vm._v("\n\t\t\t\t\t\t產品說明\n\t\t\t\t\t")])])])])
  })), _vm._v(" "), _c('section', {
    staticClass: "expert-man"
  }, [(_vm.screenWidth > 1200) ? _c('img', {
    staticClass: "expert-man-d",
    attrs: {
      "src": require("../assets/images/d-man-list.png"),
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "expert-man-m",
    attrs: {
      "src": require("../assets/images/m-man-list.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('Modal', {
    attrs: {
      "modalShownSon": _vm.modalShown,
      "votePageShowPd": _vm.modalPd,
      "imgUrl": _vm.cosmoUrl,
      "sendPage": 'man'
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "bw-logo",
    attrs: {
      "href": "http://www.cosmopolitan.com.tw/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/bw-logo.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-94669972","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Man.vue
// module id = 153
// module chunks = 0